<template>
  <v-combobox
    v-model="currentValue"
    class="select"
    label="Ort"
    :items="places"
    :hide-details="hideDetails"
    :disabled="disabled"
    :loading="loading || placesLoading"
    allow-overflow
    auto-select-first
    @update:search-input="onInput"
  />
</template>

<script>
import { api, endpoints } from '@/api'
import { mapGetters } from 'vuex'

export default {
  props: {
    value: {
      type: String,
      default: "",
    },
    hideDetails: {
      type: Boolean
    },
    loading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    onSave: {
      type: Function,
      default: () => {}
    }
  },
  data () {
    return {
      currentValue: this.value
    }
  },
  computed: {
    ...mapGetters(["placesLoading", "places"])
  },
  watch: {
    places: {
      handler () {
        if (this.places && this.places.indexOf(this.value) === -1) {
          this.$emit("input", null)
        }
      },
      immediate: true
    },
    value: {
      handler () {
        if (this.value === null) {
          this.currentValue = null
        }
      },
      immediate: true,
    },
  },
  methods: {
    onInput (value) {
      this.$emit('input', value)
    },
  },
}
</script>
